"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BarChartVerticalGridLine = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var Line_1 = require("../Line");
var BarChartUtils_1 = require("./BarChartUtils");
var theme_1 = require("../../theme");
exports.BarChartVerticalGridLine = function (_a) {
    var groupNumber = _a.groupNumber, xScaleGroup = _a.xScaleGroup, chartHeight = _a.chartHeight, group = _a.group;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        groupNumber === 0 && (react_1.default.createElement(Line_1.Line, { data: BarChartUtils_1.getLineBetweenBarGroupsData(xScaleGroup, chartHeight, true), color: theme_1.theme.colors.NTDarkGrey[100], crispEdges: true, key: group.group + "-group-line-end" })),
        react_1.default.createElement(Line_1.Line, { data: BarChartUtils_1.getLineBetweenBarGroupsData(xScaleGroup, chartHeight), color: theme_1.theme.colors.NTDarkGrey[100], crispEdges: true, key: group.group + "-group-line" })));
};
